/* eslint-disable no-undef */
let IM = null
if (typeof CUBE_APP === 'undefined') {
  window.CUBE_APP = {}
  console.warn('[cubeim config] missing!', CUBE_APP)
}
if (CUBE_APP.imlib === 'cube') {
  IM = require('./im-cube.js').default
} else {
  IM = require('./im-tx.js').default
}

export default IM



// WEBPACK FOOTER //
// ./src/store/modules/call-center/im-proxy.js